import { render, staticRenderFns } from "./pm-premium-overlay.vue?vue&type=template&id=15a42354&scoped=true&"
import script from "./pm-premium-overlay.vue?vue&type=script&lang=js&"
export * from "./pm-premium-overlay.vue?vue&type=script&lang=js&"
import style0 from "./pm-premium-overlay.vue?vue&type=style&index=0&id=15a42354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a42354",
  null
  
)

export default component.exports